import { alarm } from "@/api/alarm";

const state = {

};

const getters = {

};

const mutations = {

};

const actions = {
  getAlarmList({commit}, param) {
    return new Promise((resolve, reject) => {
      alarm(param).then(res => {
        resolve(res);
      }).catch((error) => {
        reject(error);
      });
    });
  },

}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/alarm.js